<pbc-sorter [config]="ObjektNutzungsSorterConfig" [sorter]="objektNutzungs.sorter$ | async" (sorterChange)="objektNutzungs.sorter$.next($event)"></pbc-sorter>
